import SEO from '../../components/base/SEO';
import SchemaOrg from '../../components/base/SchemaOrg';
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import PartnershipHeroSection from "./components/PartnershipHeroSection";
import CollaborationSection from "./components/CollaborationSection";
import CommunityParticipationSection from "./components/CommunityParticipationSection";

export default function PartnershipPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '파트너십',
    description: '함께 만드는 지속가능한 미래',
    url: `${siteUrl}/partnership`,
    inLanguage: 'ko-KR',
    about: {
      '@type': 'Thing',
      name: '사회적 협력',
      description: '기업 협업과 공동체 참여를 통한 지속가능한 가치 창출',
    },
  };

  return (
    <>
      <SEO
        title="파트너십 - Daygreen | 함께 만드는 지속가능한 미래"
        description="Daygreen과 함께 지속가능한 패션 산업을 만들어갈 파트너를 찾습니다. 기업 협업, 공동체 참여, 그리고 사회적 가치 창출을 위한 다양한 협력 방안을 제안합니다."
        keywords="파트너십, 기업 협업, 사회적 협력, 지속가능한 협업, CSR, 공동체 참여, 사회적 가치"
        canonical="/partnership"
        ogType="website"
      />
      <SchemaOrg schema={webPageSchema} />
      <div className="min-h-screen bg-[#FDFBF7]">
        <Navbar />
        <PartnershipHeroSection />
        <CollaborationSection />
        <CommunityParticipationSection />
        <Footer />
      </div>
    </>
  );
}